export const expenseTypes = Object.freeze({
  ALIMONY_PAYMENT: 'ALIMONY_PAYMENT',
  STUDENT_LOAN_INTEREST: 'STUDENT_LOAN_INTEREST',
  IRA_CONTRIBUTIONS: 'IRA_CONTRIBUTIONS',
  EDUCATOR_EXPENSES: 'EDUCATOR_EXPENSES',
});

export const expenseLabel = {
  DEFAULT: 'selectExpenseType',
  ALIMONY_PAYMENT: 'alimonyPayments',
  STUDENT_LOAN_INTEREST: 'studentLoanInterest',
  IRA_CONTRIBUTIONS: 'iraContributions',
  EDUCATOR_EXPENSES: 'educatorExpenses',
};

export type ExpenseType = (typeof expenseTypes)[keyof typeof expenseTypes];
